import { NavLink } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useContext } from "react";
import { CartContext } from "../context/CartContext";

export default function Navbar() {

  const { cart } = useContext(CartContext);

  return (
    <div className="flex justify-between items-center px-10 h-16 bg-gray-900 text-white shadow-md border-b border-gray-800">

      <nav className="flex gap-8 font-medium text-sm">
        <NavLink
          to="/"
          className={({ isActive }) =>
            `transition hover:text-gray-300 ${
              isActive ? "text-blue-400 border-b-2 border-blue-400 pb-1" : ""
            }`
          }
        >
          Home
        </NavLink>

        <NavLink
          to="/men"
          className={({ isActive }) =>
            `transition hover:text-gray-300 ${
              isActive ? "text-blue-400 border-b-2 border-blue-400 pb-1" : ""
            }`
          }
        >
          Men
        </NavLink>

        <NavLink
          to="/women"
          className={({ isActive }) =>
            `transition hover:text-gray-300 ${
              isActive ? "text-blue-400 border-b-2 border-blue-400 pb-1" : ""
            }`
          }
        >
          Women
        </NavLink>
      </nav>

      {/* cart icon with item count */}
      <NavLink to="/cart" className="relative hover:scale-110 transition">
        <ShoppingBag size={22} />

        {cart.length > 0 && (
          <span className="absolute -top-2 -right-3 bg-red-500 text-xs px-2 rounded-full">
            {cart.length}
          </span>
        )}
      </NavLink>

    </div>
  );
}